<mat-card class="box-bottom-border">
    <div fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-evenly">
        <div fxFlex="50%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
            <div>{{systemClass}}</div>
            <div class="aro-label">{{'ARO.SYSTEM_CLASSIFICATION' | translate}}</div>
        </div>
        <div fxFlex="50%" fxLayout="column" fxLayoutAlign="center center">
            <div>{{operatorClass}}</div>
            <div class="aro-label">{{'ARO.OPERATOR_CLASSIFICATION' | translate}}</div>
        </div>
    </div>
</mat-card>
<mat-card class="box-bottom-border">
    <div fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-evenly">
        <div fxFlex="33%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
            <div>{{fighter}}</div>
            <div class="aro-label">{{'ARO.FIGHTER' | translate}}</div>
        </div>
        <div fxFlex="34%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
            <div>{{helicopter}}</div>
            <div class="aro-label">{{'ARO.HELICOPTER' | translate}}</div>
        </div>
        <div fxFlex="33%" fxLayout="column" fxLayoutAlign="center center">
            <div>{{subsonicMissile}}</div>
            <div class="aro-label">{{'ARO.SUBSONICMISSILE' | translate}}</div>
        </div>
    </div>
</mat-card>

<mat-card class="box-bottom-border">
    <div fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-evenly">
        <div fxFlex="33%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
            <div>{{supersonicMissile}}</div>
            <div class="aro-label">{{'ARO.SUPERSONICMISSILE' | translate}}</div>
        </div>
        <div fxFlex="34%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
            <div>{{transporter}}</div>
            <div class="aro-label">{{'ARO.TRANSPORTER' | translate}}</div>
        </div>
        <div fxFlex="33%" fxLayout="column" fxLayoutAlign="center center">
            <div>{{uav}}</div>
            <div class="aro-label">{{'ARO.UAV' | translate}}</div>
        </div>
    </div>
</mat-card>